import { jsx as a } from "react/jsx-runtime";
import s from "react";
import t, { css as r } from "styled-components";
const o = {
  Circular: "circular",
  Square: "square"
}, d = t.div.withConfig({
  displayName: "Host",
  componentId: "sc-6e5l4w-0"
})(["display:inline-flex;", " ", " ", " ", ""], ({
  type: e
}) => e === o.Circular && r(["width:var(--size-8x);height:var(--size-8x);"]), ({
  type: e
}) => e === o.Square && r(["width:312px;height:var(--size-20x);"]), ({
  height: e
}) => e && r(["height:", ";"], typeof e == "number" ? `${e}px` : e), ({
  width: e
}) => e && r(["width:", ";"], typeof e == "number" ? `${e}px` : e)), c = t.div.withConfig({
  displayName: "RangoSkeleton",
  componentId: "sc-6e5l4w-1"
})(["overflow:hidden;position:relative;width:inherit;height:inherit;background-color:var(--elements-bg-color-02);&::before{content:'';position:absolute;opacity:1;top:0;left:0%;width:100%;height:100%;background:linear-gradient( to right,var(--elements-bg-color-02),var(--elements-bg-color-02),rgb(var(--color-grey-0-rgb) / var(--opacity-high)),var(--elements-bg-color-02),var(--elements-bg-color-02) );animation:slide 1500ms linear infinite;}@keyframes slide{0%{transform:translateX(-100%);}100%{transform:translateX(100%);}}", " ", ""], ({
  type: e
}) => e === o.Circular && r(["border-radius:var(--border-radius-circular);"]), ({
  type: e
}) => e === o.Square && r(["border-radius:var(--default-border-radius);"])), g = s.forwardRef(({
  type: e = o.Square,
  height: i,
  width: n
}, l) => /* @__PURE__ */ a(d, { type: e, height: i, width: n, children: /* @__PURE__ */ a(c, { type: e, ref: l, "data-testid": "rango-skeleton", "data-rango-component": "rango-skeleton", "data-is-rango": !0 }) }));
g.displayName = "RangoSkeleton";
export {
  g as RangoSkeleton
};
